/*
  Unit actions
*/
import { apollo } from '@/plugins/apollo'

// graphql files
import list from 'GraphQL/queries/units/list.gql'
import mobileList from 'GraphQL/queries/units/mobileUnits.gql'

export default {
  async getList ({ state, dispatch, commit, rootState }, payload = false) {
    if (payload) {
      commit('setLoading', true, { root: true })
    }

    await apollo.query({
      query: list,
      variables: {
        apiToken: rootState.users.entity.apiToken,
        language: rootState.language
      },
      fetchPolicy: 'no-cache'
    }).then((response) => {
      const { status, result } = response.data.units

      switch (status) {
        case 'OK':
          commit('setList', result)
          break

        case 'UNPROCESSABLE':
          commit('toggleSnackbar', undefined, { root: true })
          break
      }
    }).catch((error) => {
      console.error('Actions Units Error: ', error)
      commit('toggleSnackbar', undefined, { root: true })
    }).finally(() => {
      if (payload) {
        commit('setLoading', false, { root: true })
      }
    })
  },

  async getMobileList ({ state, dispatch, commit, rootState }, payload = false) {
    if (payload) {
      commit('setLoading', true, { root: true })
    }

    await apollo.query({
      query: mobileList,
      variables: {
        apiToken: rootState.users.entity.apiToken,
        language: rootState.language
      },
      fetchPolicy: 'no-cache'
    }).then((response) => {
      const { status, result } = response.data.mobileUnits

      switch (status) {
        case 'OK':
          commit('appendMobileList', result)
          break

        case 'UNPROCESSABLE':
          commit('toggleSnackbar', undefined, { root: true })
          break
      }
    }).catch((error) => {
      console.error('Actions Units Error: ', error)
      commit('toggleSnackbar', undefined, { root: true })
    }).finally(() => {
      if (payload) {
        commit('setLoading', false, { root: true })
      }
    })
  }
}
